import React from "react";
import ModalBasic from "../../../components/modal/ModalBasic";
import FormDmProduct from "../Form/FormDmProduct";

export default function ModalDmMedicines({
	dataImage,
	dataDetail,
	handleManagerData,
	isOpenForm,
	setIsOpenForm,
}) {
	return (
		<div>
			<ModalBasic
				// zIndex={1035}
				id={"Medicines-create"}
				title={
					<div className="flex justify-start gap-2 items-center w-[calc(100%-20px)]">
						<span>Thuốc</span>
					</div>
				}
				open={isOpenForm === "create" ? true : false}
				onCancel={() => {
					setIsOpenForm(false);
				}}
				footer={null}
				width={"550px"}
				styleBodyForm={{ paddingTop: "0" }}
				labelAlign="left"
				handleManager={(data) => {
					handleManagerData({
						...data,
						ma_dvt: "viên",
						exfields: {
							gia_uu_dai: data?.gia_uu_dai,
							dien_giai: data?.dien_giai,
							loai_vat_tu: "Medicines",
						},
					});
					setIsOpenForm(false);
				}}
			>
				<FormDmProduct isCheckBoxServices={false} />
			</ModalBasic>

			<ModalBasic
				// zIndex={1035}
				id={"Medicines-edit"}
				title={
					<div className="flex justify-start gap-2 items-center w-[calc(100%-20px)]">
						<span>Thuốc</span>
					</div>
				}
				open={isOpenForm === "edit" ? true : false}
				onCancel={() => {
					setIsOpenForm(false);
				}}
				footer={null}
				width={"550px"}
				styleBodyForm={{ paddingTop: "0" }}
				labelAlign="left"
				handleManager={(data) => {
					handleManagerData({
						...dataDetail,
						...data,
						exfields: {
							...dataDetail.exfields,
							gia_uu_dai: data?.gia_uu_dai,
							dien_giai: data?.dien_giai,
							loai_vat_tu: "Medicines",
						},
					});
					setIsOpenForm(false);
				}}
				data={{
					picture: dataDetail?.picture,
					ten_vt: dataDetail?.ten_vt,
					gia_ban_le: dataDetail?.gia_ban_le,
					gia_uu_dai: dataDetail?.exfields?.gia_uu_dai,
					dien_giai: dataDetail?.exfields?.dien_giai,
				}}
			>
				<FormDmProduct
					isCheckBoxServices={false}
					dataImage={dataImage}
				/>
			</ModalBasic>
		</div>
	);
}
